import { useEffect } from "react";
import WebSocketManager from "./websocketManager";

export default function WebSocketInitializer() {
  useEffect(() => {
    WebSocketManager.getInstance().connect();
  }, []);

  return null;
}
